<template>
  <Dialog
      header="New Content"
      v-model:visible="showModal"
      modal
      :style="{'width':'40%'}"
      @hide="hideModal"
  >
    <div class="row mb-3 mt-3">
      <div class="col-md-12 form-group">
        <label class="d-block">Title*:</label>
        <InputText
            class="w-100"
            type="text"
            v-model="newContent.title"
        />
      </div>
      <div class="col-md-12 form-group">
        <label class="d-block">Text*:</label>
        <Textarea
            class="w-100"
            type="text"
            rows="8"
            v-model="newContent.text"
        />
      </div>
      <div class="col-md-6 form-group">
        <label class="d-block">General:</label>
        <InputSwitch
            v-model="newContent.isGeneral"
        />
      </div>
      <div class="col-md-6 form-group" v-if="newContent.isGeneral">
        <label class="d-block">Date:</label>
        <Datepicker v-model="newContent.startDate" format="dd/MM/yyyy"></Datepicker>
      </div>
      <div class="row" v-if="!newContent.isGeneral">
        <div class="col-md-6 form-group">
          <label class="d-block">House:</label>
          <Dropdown
              class="w-100"
              v-model="newContent.houseId"
              :options="houses"
              optionLabel="name"
              optionValue="id"
              placeholder="Select House"
          />
        </div>
        <div class="col-md-6 form-group">
          <label class="d-block">Score*:</label>
          <InputNumber
              class="w-100"
              buttonLayout="horizontal"
              mode="decimal"
              v-model="newContent.score"
          />
        </div>
        <div class="col-md-6 form-group">
          <label class="d-block">Min Age:</label>
          <InputNumber
              class="w-100"
              buttonLayout="horizontal"
              mode="decimal"
              v-model="newContent.minAge"
          />
        </div>
        <div class="col-md-6 form-group">
          <label class="d-block">Max Age:</label>
          <InputNumber
              class="w-100"
              buttonLayout="horizontal"
              mode="decimal"
              v-model="newContent.maxAge"
          />
        </div>
        <div class="col-md-6 form-group">
          <label class="d-block">Gender:</label>
          <Dropdown
              class="w-100"
              :options="[{'id': 0, 'value':'All'},{'id': 1 , 'value':'Man'}, {'id': 2 , 'value':'Woman'}]"
              v-model="newContent.gender"
              optionLabel="value"
              optionValue="id"
          />
        </div>
        <div class="col-md-6 form-group">
          <label class="d-block">Relationship:</label>
          <MultiSelect
              class="w-100"
              :options="relationships"
              v-model="newContent.relationshipStatusIds"
              optionLabel="name"
              optionValue="id"
              placeholder="Select Relationship Statuses"
          />
        </div>
        <div class="col-md-6 form-group">
          <label class="d-block">Occupations:</label>
          <MultiSelect
              class="w-100"
              v-model="newContent.occupationIds"
              :options="occupations"
              optionLabel="name"
              optionValue="id"
              placeholder="Select Occupations"/>
        </div>
        <div class="col-md-6 form-group">
          <label class="d-block">Tags:</label>
          <MultiSelect
              class="w-100"
              v-model="newContent.categoryIds"
              :options="categories"
              optionLabel="name"
              optionValue="id"
              placeholder="Select Tags"/>
        </div>
      </div>
    </div>
    <Message v-for="msg of messages" :severity="msg.severity" :key="msg.id" :life="5000" :sticky="false">
      {{ msg.content }}
    </Message>
    <div class="modal-footer">
      <button
          type="button"
          class="btn btn-default"
          @click="hideModal"
      >
        Close
      </button>
      <Button
          label="Save"
          icon="pi pi-save"
          iconPos="left"
          @click="addNewContent"
      />
    </div>
  </Dialog>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    contentType: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.newContent.categoryIds = this.categories.map(category => category.id);
    this.newContent.occupationIds = this.occupations.map(occupation => occupation.id);
    this.newContent.relationshipStatusIds = this.relationships.map(relationship => relationship.id);
  },
  data() {
    return {
      newContent: {
        isGeneral: true,
        gender: 0,
        categoryIds: [],
        occupationIds: [],
        relationshipStatusIds: [],
        minAge: 0,
        maxAge: 100
      },
      messages: [],
      messageCount: 0
    }
  },
  computed: {
    ...mapGetters(['occupations', 'signs', 'houses', 'relationships', 'occupationIds', 'relationshipIds', 'categories']),
    showModal: {
      get() {
        return this.show;
      },
      set() {
        this.hideModal();
      }
    },
  },
  methods: {
    hideModal() {
      this.$emit('hide');
    },
    addNewContent() {
      if (!(this.newContent.title && this.newContent.text && (this.newContent.houseId != null || this.newContent.isGeneral))) {
        this.messages = [{severity: 'warn', content: 'Required fields must be entered.', id: this.messageCount++}];
        return;
      }
      this.$appAxios.post("admin/content/" + this.contentType, {
        type: this.contentType,
        houseId: this.newContent.houseId,
        ascendantSignId: this.newContent.ascendantSignId,
        score: this.newContent.score,
        minAge: this.newContent.minAge,
        maxAge: this.newContent.maxAge,
        gender: this.newContent.gender,
        relationshipStatusIds: this.newContent.relationshipStatusIds,
        occupationIds: this.newContent.occupationIds,
        startDate: this.newContent.startDate,
        endDate: this.newContent.startDate,
        title: this.newContent.title,
        text: this.newContent.text,
        isGeneral: this.newContent.isGeneral,
        categoryIds: this.newContent.categoryIds
      }).then(() => {
        this.hideModal();
        this.$toast.add({severity: 'success', summary: 'Success', detail: 'Content added successfully', life: 3000});
        this.$emit('refresh');
      }).catch(() => {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'An error occured while adding content',
          life: 3000
        });
        this.$emit('refresh');
      });
    },
  }
}
</script>
<style>
</style>